// Helper functions for data processing
export const getUniqueValues = (data, field) => {
  const values = data.map(item => {
    if (field.includes('.')) {
      return field.split('.').reduce((obj, key) => obj?.[key], item);
    }
    return item[field];
  }).filter(Boolean);
  return [...new Set(values)].sort();
};

// Format phone number to (xxx) xxx-xxxx format
export const formatPhoneNumber = (phone) => {
  if (!phone) return '';
  
  // Remove all non-digit characters
  const cleaned = phone.replace(/\D/g, '');
  
  // Check if we have exactly 10 digits
  if (cleaned.length !== 10) {
    // Return original if not 10 digits (might be international or invalid)
    return phone;
  }
  
  // Format as (xxx) xxx-xxxx
  return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
};

// Helper functions for area code processing
export const extractAreaCode = (phone) => {
  if (!phone) return null;
  const matches = phone.match(/\(?(\d{3})\)?/);
  return matches ? matches[1] : null;
};

export const getRegionFromAreaCode = (phone) => {
  const areaCode = extractAreaCode(phone);
  if (!areaCode) return null;
  
  const code = parseInt(areaCode);
  if (code >= 200 && code <= 299) return 'northeast';
  if (code >= 300 && code <= 399) return 'midwest';
  if (code >= 400 && code <= 599) return 'southeast';
  if (code >= 600 && code <= 799) return 'west';
  if (code >= 800 && code <= 999) return 'canada';
  return 'other';
};

// Filter application logic
export const applyFilters = (data, filters) => {
  return data.filter(customer => {
    // Company filter
    if (filters.company !== 'all' && customer.companyName !== filters.company) {
      return false;
    }

    // Email domain filter
    if (filters.emailDomain !== 'all') {
      const domain = customer.email?.split('@')[1];
      if (domain !== filters.emailDomain) {
        return false;
      }
    }

    // Region filter (based on area code)
    if (filters.region !== 'all') {
      const region = getRegionFromAreaCode(customer.phone);
      if (region !== filters.region) {
        return false;
      }
    }

    // Area code filter
    if (filters.areaCode !== 'all') {
      const areaCode = extractAreaCode(customer.phone);
      if (areaCode !== filters.areaCode) {
        return false;
      }
    }

    return true;
  });
};

// Sorting application logic
export const applySorting = (data, sortConfig) => {
  if (!sortConfig.field) return data;

  return [...data].sort((a, b) => {
    let aValue = a[sortConfig.field];
    let bValue = b[sortConfig.field];

    // Handle nested fields
    if (sortConfig.field.includes('.')) {
      aValue = sortConfig.field.split('.').reduce((obj, key) => obj?.[key], a);
      bValue = sortConfig.field.split('.').reduce((obj, key) => obj?.[key], b);
    }

    // Handle strings (most common for customers)
    if (typeof aValue === 'string' && typeof bValue === 'string') {
      aValue = aValue.toLowerCase();
      bValue = bValue.toLowerCase();
    }

    // Handle null/undefined values
    if (aValue == null && bValue == null) return 0;
    if (aValue == null) return 1;
    if (bValue == null) return -1;

    if (aValue < bValue) {
      return sortConfig.direction === 'asc' ? -1 : 1;
    }
    if (aValue > bValue) {
      return sortConfig.direction === 'asc' ? 1 : -1;
    }
    return 0;
  });
}; 